import React from 'react';

class Color extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    });
  }

  render() {
    let className = this.props.color.chosen ? 'colorset-maker__color colorset-maker__color--chosen' : 'colorset-maker__color';
    const style = { color: this.props.color.color };
    const price = Number(this.props.color.price * 40).toFixed(2);
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }
    if (this.state.isHovered) {
      style.backgroundColor = style.color;
      style.color = '#FFFFFF';
    }
    return (
      <button
        className={className}
        style={style}
        onClick={this.props.onClick}
        onMouseOver={this.handleHover}
        onMouseOut={this.handleHover}
        onBlur={this.handleHover}
        onFocus={this.handleHover}
        onAnimationEnd={this.props.onAnimationEnd}
      >
        <img
          src={this.props.color.image}
          alt={this.props.color.title}
          className="colorset-maker__color-image"
        />
        <span className="colorset-maker__color-title">{this.props.color.title}</span>
        <span className="colorset-maker__color-price">{price} &euro;</span>
      </button>
    );
  }
}

export default Color;



// WEBPACK FOOTER //
// ./src/components/color.js